import styled from 'styled-components';

import { BodySmallSemiBold, Colour } from '@xemplo/style-constants';

export const SelectAll = styled.div`
  ${BodySmallSemiBold};
  background: ${Colour.Light[100]};
  color: ${Colour.Gray[500]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  outline: none;
  height: 48px;
  padding: 0px 24px;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid ${Colour.Gray[200]};

  &.no-border-radius {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:focus-visible {
    background: ${Colour.Gray[50]};
  }
`;
